import { render, staticRenderFns } from "./FzorganLicenseApplys.vue?vue&type=template&id=fd0facc6&scoped=true&"
import script from "./FzorganLicenseApplys.vue?vue&type=script&lang=js&"
export * from "./FzorganLicenseApplys.vue?vue&type=script&lang=js&"
import style0 from "./FzorganLicenseApplys.vue?vue&type=style&index=0&id=fd0facc6&scoped=true&lang=css&"
import style1 from "./FzorganLicenseApplys.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0facc6",
  null
  
)

export default component.exports